import React from "react";
import { string, bool } from "prop-types";
import "./designation.m.css";

export const Designation = ({ children, hasBorder = false }) => {
  return (
    <div styleName={`designation ${hasBorder ? "has-border" : ""}`}>
      {children}
    </div>
  );
};

Designation.propTypes = {
  children: string.isRequired,
  hasBorder: bool,
};